import React from 'react'

const GiftShipmentDarkMode: React.FC<React.HTMLAttributes<SVGElement>> = () => (
  <svg
    fill="none"
    height="44"
    viewBox="0 0 62 44"
    width="62"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2564_1085)">
      <path
        d="M11.1501 42.4301C14.3401 42.4301 16.9301 39.8401 16.9301 36.6501C16.9301 33.4601 14.3401 30.8701 11.1501 30.8701C7.96012 30.8701 5.37012 33.4601 5.37012 36.6501C5.37012 39.8401 7.96012 42.4301 11.1501 42.4301Z"
        fill="url(#paint0_linear_2564_1085)"
      />
      <path
        d="M50.2701 42.4301C53.4601 42.4301 56.0501 39.8401 56.0501 36.6501C56.0501 33.4601 53.4601 30.8701 50.2701 30.8701C47.0801 30.8701 44.4901 33.4601 44.4901 36.6501C44.4901 39.8401 47.0801 42.4301 50.2701 42.4301Z"
        fill="url(#paint1_linear_2564_1085)"
      />
      <path
        d="M52.0201 17.1303C51.4801 16.9303 51.0201 16.5503 50.7101 16.0603L46.3001 8.89031L52.0201 17.1303Z"
        fill="#A0DCFF"
      />
      <path
        d="M52.1701 17.3503H39.3301C38.2701 17.3503 37.4101 16.4903 37.4101 15.4303V10.8103C37.4101 9.75031 38.2701 8.89031 39.3301 8.89031H46.3001L50.7101 16.0603C51.0201 16.5503 51.4801 16.9303 52.0201 17.1303L52.1701 17.3503Z"
        fill="url(#paint2_linear_2564_1085)"
      />
      <path
        d="M11.1501 29.8703C14.0701 29.8703 16.5601 31.7303 17.5101 34.3203H44.4401C45.3901 31.7303 47.8801 29.8703 50.8001 29.8703C53.7201 29.8703 56.2101 31.7303 57.1601 34.3203H57.5801C58.4601 34.3203 59.1701 33.6103 59.1701 32.7303V21.7703C59.1701 21.0903 58.7401 20.4903 58.1001 20.2703L52.4801 18.3503H39.3401C37.7301 18.3503 36.4201 17.0403 36.4201 15.4303V10.8103C36.4201 9.20031 37.7301 7.89031 39.3401 7.89031H44.5101L44.2101 7.39031C43.9201 6.92031 43.4201 6.64031 42.8601 6.64031H36.0201C35.1401 6.64031 34.4301 7.35031 34.4301 8.23031V24.4403C34.4301 26.4303 32.8201 28.0403 30.8401 28.0403H4.43008C3.55008 28.0403 2.83008 28.7503 2.83008 29.6303V32.7303C2.83008 33.6103 3.55008 34.3203 4.43008 34.3203H4.79008C5.74008 31.7303 8.23008 29.8703 11.1501 29.8703Z"
        fill="url(#paint3_linear_2564_1085)"
      />
      <path
        d="M60.1701 21.8903C58.0101 21.8903 56.2501 23.6403 56.2501 25.8103C56.2501 27.9803 58.0001 29.7303 60.1701 29.7303V21.8903Z"
        fill="#F6F4F0"
      />
      <path
        d="M30.6201 1.57031H4.63008C3.08008 1.57031 1.83008 2.82031 1.83008 4.37031V24.2403C1.83008 25.7903 3.08008 27.0403 4.63008 27.0403H30.6201C32.1701 27.0403 33.4201 25.7903 33.4201 24.2403V4.37031C33.4201 2.82031 32.1701 1.57031 30.6201 1.57031Z"
        fill="url(#paint4_linear_2564_1085)"
      />
      <path
        d="M54.6601 19.1803L54.6501 19.1703V19.1803H54.6601Z"
        fill="#121112"
      />
      <path
        d="M58.7401 18.3803L52.6501 16.3003L47.2001 8.45031L46.8501 7.89031H46.8301L45.8901 6.35031C45.2401 5.28031 44.1001 4.64031 42.8401 4.64031H36.0001C35.4301 4.64031 34.8901 4.79031 34.4101 5.03031V4.37031C34.4101 2.27031 32.7101 0.570312 30.6101 0.570312H4.63008C2.53008 0.570313 0.830078 2.27031 0.830078 4.37031V24.2403C0.830078 25.3203 1.29008 26.2903 2.02008 26.9903C1.29008 27.6403 0.830078 28.5803 0.830078 29.6303V32.7303C0.830078 34.7003 2.43008 36.2903 4.39008 36.3203C4.39008 36.4303 4.37008 36.5403 4.37008 36.6503C4.37008 40.3903 7.41008 43.4303 11.1501 43.4303C14.8901 43.4303 17.9301 40.3903 17.9301 36.6503C17.9301 36.5403 17.9201 36.4303 17.9101 36.3203H44.0301C44.0301 36.4303 44.0101 36.5403 44.0101 36.6503C44.0101 40.3903 47.0501 43.4303 50.7901 43.4303C54.5301 43.4303 57.5701 40.3903 57.5701 36.6503C57.5701 36.5403 57.5601 36.4303 57.5501 36.3203H57.5701C59.5501 36.3203 61.1601 34.7203 61.1601 32.7403V21.7803C61.1601 20.2403 60.1801 18.8803 58.7301 18.3803H58.7401ZM45.7401 9.89031L45.9001 10.1403L49.7101 16.3503H39.3301C38.8201 16.3503 38.4101 15.9403 38.4101 15.4303V10.8103C38.4101 10.3003 38.8201 9.89031 39.3301 9.89031H45.7401ZM2.83008 4.37031C2.83008 3.38031 3.64008 2.57031 4.63008 2.57031H30.6201C31.6101 2.57031 32.4201 3.38031 32.4201 4.37031V24.2403C32.4201 25.2303 31.6101 26.0403 30.6201 26.0403H4.63008C3.64008 26.0403 2.83008 25.2303 2.83008 24.2403V4.37031ZM15.9301 36.6503C15.9301 39.2803 13.7801 41.4303 11.1501 41.4303C8.52008 41.4303 6.37008 39.2803 6.37008 36.6503C6.37008 36.5403 6.40008 36.4303 6.40008 36.3203C6.42008 35.9703 6.49008 35.6403 6.58008 35.3203C6.68008 34.9703 6.82008 34.6303 7.00008 34.3203C7.82008 32.8703 9.36008 31.8703 11.1501 31.8703C12.9401 31.8703 14.4701 32.8703 15.3001 34.3203C15.4801 34.6303 15.6201 34.9703 15.7201 35.3203C15.8101 35.6403 15.8801 35.9703 15.9001 36.3203C15.9001 36.4303 15.9301 36.5403 15.9301 36.6503ZM50.8001 41.4303C48.1701 41.4303 46.0201 39.2803 46.0201 36.6503C46.0201 36.5403 46.0501 36.4303 46.0501 36.3203C46.0701 35.9703 46.1401 35.6403 46.2301 35.3203C46.3301 34.9703 46.4701 34.6303 46.6501 34.3203C47.4701 32.8703 49.0101 31.8703 50.8001 31.8703C52.5901 31.8703 54.1201 32.8703 54.9501 34.3203C55.1301 34.6303 55.2701 34.9703 55.3701 35.3203C55.4601 35.6403 55.5301 35.9703 55.5501 36.3203C55.5501 36.4303 55.5801 36.5403 55.5801 36.6503C55.5801 39.2803 53.4301 41.4303 50.8001 41.4303ZM59.1701 32.7303C59.1701 33.6103 58.4601 34.3203 57.5801 34.3203H57.1601C56.2101 31.7303 53.7201 29.8703 50.8001 29.8703C47.8801 29.8703 45.3901 31.7303 44.4401 34.3203H17.5101C16.5601 31.7303 14.0701 29.8703 11.1501 29.8703C8.23008 29.8703 5.74008 31.7303 4.79008 34.3203H4.43008C3.55008 34.3203 2.83008 33.6103 2.83008 32.7303V29.6303C2.83008 28.7503 3.55008 28.0403 4.43008 28.0403H30.8401C32.8201 28.0403 34.4301 26.4303 34.4301 24.4403V8.23031C34.4301 7.35031 35.1401 6.64031 36.0201 6.64031H42.8601C43.4201 6.64031 43.9201 6.92031 44.2101 7.39031L44.5101 7.89031H39.3301C37.7201 7.89031 36.4101 9.20031 36.4101 10.8103V15.4303C36.4101 17.0403 37.7201 18.3503 39.3301 18.3503H52.4301L54.6401 19.1703L54.5601 19.0603L58.0901 20.2703C58.4801 20.4103 58.7801 20.6903 58.9601 21.0403C56.8301 21.5803 55.2401 23.5003 55.2401 25.8003C55.2401 28.1003 56.9301 30.1503 59.1601 30.6203V32.7303H59.1701ZM59.1701 23.0603V28.5403C58.0501 28.1303 57.2501 27.0603 57.2501 25.8003C57.2501 24.5403 58.0501 23.4703 59.1701 23.0603Z"
        fill="#121112"
      />
      <path
        d="M8.37008 13.1003C8.37008 14.0203 8.50008 14.8103 8.89008 15.5903C10.0701 18.3503 12.4301 20.3103 15.0601 21.7603C15.8501 22.1503 16.7701 22.8103 17.6801 22.8103C18.5901 22.8103 19.5201 22.1503 20.3001 21.6303C22.6601 20.3203 24.8901 18.6103 26.2101 16.2503C27.5301 13.8903 27.3901 10.8703 25.4201 8.90031C23.1901 6.67031 19.6501 7.06031 17.6801 9.29031C16.5001 8.11031 14.9201 7.32031 13.2201 7.45031C10.3301 7.58031 8.36008 10.2103 8.36008 12.9603V13.0903H8.37008V13.1003Z"
        fill="#EB779F"
      />
      <path
        d="M17.6901 23.8103C16.7201 23.8103 15.8301 23.3203 15.1301 22.9303C14.9601 22.8303 14.7901 22.7403 14.6201 22.6603C11.3301 20.8503 9.10008 18.6103 7.98008 15.9903C7.57008 15.1703 7.37008 14.2603 7.37008 13.1003V12.9703C7.37008 9.47031 9.92008 6.61031 13.1801 6.46031C14.7301 6.34031 16.3001 6.86031 17.6601 7.93031C18.7801 7.00031 20.1801 6.46031 21.6401 6.41031C23.3301 6.36031 24.9401 6.99031 26.1401 8.19031C28.3301 10.3803 28.7201 13.8103 27.0901 16.7303C25.8601 18.9403 23.8001 20.8303 20.8001 22.5003L20.7201 22.5603C19.8901 23.1203 18.8501 23.8103 17.6901 23.8103ZM13.6001 8.44031C13.5001 8.44031 13.4001 8.44031 13.3001 8.44031C10.8301 8.55031 9.37008 10.8203 9.37008 12.9603V13.0903C9.37008 13.9403 9.49008 14.5503 9.79008 15.1403C10.7601 17.3903 12.6901 19.3103 15.5501 20.8803C15.7001 20.9603 15.9001 21.0603 16.1001 21.1703C16.6301 21.4703 17.2401 21.8003 17.6901 21.8003C18.2501 21.8003 18.9701 21.3103 19.6101 20.8903L19.7601 20.7903C22.5001 19.2603 24.3001 17.6303 25.3501 15.7603C26.5301 13.6303 26.2801 11.1603 24.7301 9.60031C23.9201 8.79031 22.8201 8.36031 21.7001 8.41031C20.4601 8.45031 19.2701 9.01031 18.4401 9.95031C18.2601 10.1603 18.0001 10.2803 17.7201 10.2903C17.4401 10.3103 17.1801 10.1903 16.9801 10.0003C16.3801 9.40031 15.1801 8.44031 13.6001 8.44031Z"
        fill="#121112"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2564_1085"
        x1="31.0001"
        x2="31.0001"
        y1="49.103"
        y2="0.570312"
      >
        <stop stopColor="#5C2F57" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2564_1085"
        x1="31.0001"
        x2="31.0001"
        y1="49.103"
        y2="0.570312"
      >
        <stop stopColor="#5C2F57" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2564_1085"
        x1="31.0001"
        x2="31.0001"
        y1="49.1044"
        y2="0.570312"
      >
        <stop stopColor="#5C2F57" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2564_1085"
        x1="24.8633"
        x2="60.5146"
        y1="38.1038"
        y2="26.1852"
      >
        <stop offset="0.24" stopColor="#F4D04E" />
        <stop offset="1" stopColor="#E96C4C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2564_1085"
        x1="5.96824"
        x2="49.0231"
        y1="39.1897"
        y2="1.07007"
      >
        <stop stopColor="#75AC6F" />
        <stop offset="1" stopColor="#A6D2F1" />
      </linearGradient>
      <clipPath id="clip0_2564_1085">
        <rect
          fill="white"
          height="42.86"
          transform="translate(0.830078 0.570312)"
          width="60.34"
        />
      </clipPath>
    </defs>
  </svg>
)

export default GiftShipmentDarkMode
